function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.0837H5.83332C3.33332 17.0837 1.66666 15.8337 1.66666 12.917V7.08366C1.66666 4.16699 3.33332 2.91699 5.83332 2.91699H14.1667C16.6667 2.91699 18.3333 4.16699 18.3333 7.08366V12.917C18.3333 15.8337 16.6667 17.0837 14.1667 17.0837Z",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.5L11.5583 9.58333C10.7 10.2667 9.29167 10.2667 8.43334 9.58333L5.83334 7.5",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerMail);
export default __webpack_public_path__ + "static/media/customer-mail.44c6b5562965980d45097c2cf21c408b.svg";
export { ForwardRef as ReactComponent };